module.exports = __webpack_public_path__ + "static/f-VLopez-0fff148e69a2649c20d2838971343c84.jpg";